import React, { useState, useCallback, useEffect } from 'react';
import { Box, Fade } from '@mui/material';
import { ConfigArea, ResultArea } from '../components';
import { configurations } from '../assets/configurations';

const ConfigPage = () => {
  const [matchedConfiguration, setMatchedConfiguration] = useState(null);
  const [configChanged, setConfigChanged] = useState(false);

  function findBestConfiguration(configurations, requiredPower, requiredCapacity) {
    return Object.values(configurations)
      .filter(config => config.capacity >= requiredCapacity && config.power >= requiredPower)
      .reduce((best, current) => {
        if (!best) return current;
        if (current.capacity < best.capacity || current.power < best.power) return current;
        return best;
      }, null);
  }

  const updateConfiguration = useCallback((requiredPower, requiredCapacity) => {
    const bestConfig = findBestConfiguration(configurations, requiredPower, requiredCapacity);
    setMatchedConfiguration(bestConfig ? bestConfig : null); // Reset image loaded state
  }, []);

  useEffect(() => {
    setConfigChanged(true);
  }, [matchedConfiguration])

  return (
    <Box>
      <Box sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}>
        <Box sx={{ position: 'relative' }}>
          <Box className="ConfigPage-bg">
            <Fade in={configChanged} onExit={() => setConfigChanged(false)} timeout={500}>
              <img 
                src={'/' + (matchedConfiguration ? matchedConfiguration.image : 'images/container-bg.png')} 
                alt={matchedConfiguration ? matchedConfiguration.productName : 'BESS Gen2 example background'}
                style={{ display: configChanged ? 'block' : 'none' }}
              />
            </Fade>
          </Box>
          <ConfigArea
            matchedConfiguration={matchedConfiguration}
            updateConfiguration={updateConfiguration}
            configurations={configurations}
          />
          <ResultArea matchedConfiguration={matchedConfiguration} />
        </Box>
      </Box>
    </Box>
  );
};

ConfigPage.propTypes = {};

export { ConfigPage };
